import React, { useState, useEffect, useRef } from 'react';
import { f7, Page, Link, Button, Icon, Input } from 'framework7-react';
import axios from 'axios';
import { API_BASE_URL, API_AUTH, IMG_URL } from './../globals';

const ProfileUpdatePage = () => {
  const [data, setData] = useState([]);
  const [citydata, setCityData] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);
  
  const getImageAsBase64 = (imageUrl) => {
    return new Promise((resolve, reject) => {
      fetch(imageUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            const base64String = reader.result;
            resolve(base64String);
          };
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
        .catch(reject);
    });
  };
  const handleDivClick = () => {
    fileInputRef.current.click();
  };
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64Image = reader.result
      // setImageFile(file);
      setImagePreview(base64Image);
    };
    reader.readAsDataURL(file);      
    console.log(file);
  };
  useEffect(() => {
    axios.get(API_BASE_URL + 'customers', {
        headers: {
          'Authorization': 'Basic ' + API_AUTH
        },
        params: {
          id: localStorage.getItem('id'),
          limits: 1
        }
      })
      .then(response => { 
        setData(response.data[0]);
        const imageUrl = response.data[0].cust_image;
        if(imageUrl){
          getImageAsBase64(IMG_URL+response.data[0].cust_image)
          .then(base64String => setImagePreview(base64String))
          .catch(error => console.log(error));
        }
  })
      .catch(error => console.log(error));
  }, []);
  
  useEffect(() => {
    axios.get(API_BASE_URL + 'state', {
        headers: {
          'Authorization': 'Basic ' + API_AUTH
        }
      })
      .then(response => setCityData(response.data))
      .catch(error => console.log(error));
  }, []);

  const newData = {
    ...data, // Copy existing data properties
    cust_image :imagePreview ,
   
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const id = localStorage.getItem('id');

    axios.put(API_BASE_URL + 'customers/id/'+id, newData, {
      headers: {
        'Authorization': 'Basic ' + API_AUTH
      }
    })
    .then(response => {
      if (response.data.status === 'failure' && response.data.message) {
        const errorMessagesArray = Object.values(response.data.message);
        const errorMessagesWithBreaks = errorMessagesArray.join('<br/>');
        f7.toast.create({
          text: errorMessagesWithBreaks,
          position: 'top',
          cssClass: 'bg-color-red',
          closeTimeout: 3000
        }).open();
      } else {
        f7.views.main.router.navigate('/main/', {
          reloadAll: true
        });
        f7.tab.show('#tab-5');
        f7.toast.create({
          text: 'Profile Information Updated ..!',
          position: 'top',
          cssClass: 'bg-color-teal',
          closeTimeout: 3000
        }).open();        
      }
    })
    .catch(error => {
      console.log(error);
      f7.toast.create({
        text: 'Something went wrong..!',
        position: 'top',
        cssClass: 'bg-color-red',
        closeTimeout: 3000
      }).open();
    })

      // .then(response => f7.toast.create({
      //   text: 'Profile Information Updated',
      //   position: 'top',
      //   cssClass: 'bg-color-teal',
      //   closeTimeout: 2000
      // }).open())
      // .catch(error => {  
      //   f7.dialog.alert('Error updating data!')
      // });
  }
  
  return (
    <Page className='bg-white'>
      <div className="container container-table  ">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="container-lg custom-container p-0">
              <div className="header-panel">
                <Link href="#" back><Icon ios="material:keyboard_arrow_left" aurora="material:keyboard_arrow_left" md="material:keyboard_arrow_left" className='theme-dark' backLink="Back" ></Icon></Link>
                <h2>Profile Information</h2>
              </div>
            </div>
          </header>
          <section className='profile-form mt-3'>
            <div className="custom-container p-0" onClick={handleDivClick}>
              <div className="profile-cover">
              {imagePreview ? (
                  
                    <img className="img-fluid profile-pic" src={imagePreview} alt="" />
                  
                ) : (
                  <div className=" no-image-placeholder text-center">
                    <div className="img-fluid profile-pic">
                      <Icon material="photo_camera" size={30} />
                      {/* <p>Tap to upload image</p> */}
                    </div>
                  </div>
                )}
                  <input
                        type="file"
                        ref={fileInputRef}
                        accept="image/*"
                        onChange={handleImageChange}
                        style={{ display: "none" }}
                        onInput={(event) => setData({...data, rest_img: event.target.value})}
                      />
              </div>
              <div className="profile-name">
                <h5>{data.cust_fname} {data.cust_lname}</h5>
                <h6>{data.cust_email}</h6>
              </div>
            </div>
          </section>
      {/* <Navbar backLink="Back" title="Profile Infomation" noShadow className="header-panel text-4"></Navbar> */}
          <section className="section-b-space">
            <div className="custom-container p-0">
              <form onSubmit={handleSubmit} className="auth-form">
                <div className="form-group">
                  <label className="form-label fw-semibold">First Name</label>
                  <div className="form-input mb-4">
                    <Input type="text" className="form-control" required validate pattern=".{3,75}" minlength="3" placeholder="Enter first name" value={data.cust_fname} onInput={(event) => setData({...data, cust_fname: event.target.value})}/>
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label fw-semibold">Last Name</label>
                  <div className="form-input mb-4">
                    <Input type="text" className="form-control" placeholder="Enter last name" required validate pattern=".{3,75}" value={data.cust_lname} onInput={(event) => setData({...data, cust_lname: event.target.value})}/>
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label fw-semibold">Email</label>
                  <div className="form-input mb-4">
                    <Input type="email" readonly={true} className="form-control" placeholder="Enter email" value={data.cust_email} onInput={(event) => setData({...data, cust_email: event.target.value})}/>
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label fw-semibold">Phone Number</label>
                  <div className="form-input mb-4">
                    <Input type="tel" className="form-control" required validate pattern="^[0-9]{10}$" placeholder="Enter phone number" value={data.cust_contact_no} onInput={(event) => setData({...data, cust_contact_no: event.target.value})}/>
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label fw-semibold">Company Name</label>
                  <div className="form-input mb-4">
                    <Input type="text" className="form-control" placeholder="Enter company name" value={data.cust_company_name} onInput={(event) => setData({...data, cust_company_name: event.target.value})}/>
                  </div>
                </div>
                <h4 className='mb-3 fw-bold'>Address Information</h4>
                <div className="form-group">
                  <label className="form-label fw-semibold">Address 1</label>
                  <div className="form-input mb-4">
                    <Input type="text" className="form-control" required placeholder="Enter address" value={data.add_lin_1} onInput={(event) => setData({...data, add_lin_1: event.target.value})}/>
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label fw-semibold">Address 2</label>
                  <div className="form-input mb-4">
                    <Input type="text" className="form-control" placeholder="Enter address" value={data.add_lin_2} onInput={(event) => setData({...data, add_lin_2: event.target.value})}/>
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label fw-semibold">City</label>
                  <div className="form-input mb-4">
                    <Input type="text" className="form-control" required placeholder="Enter city" value={data.city} onInput={(event) => setData({...data, city: event.target.value})}/>
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label fw-semibold">State</label>
                  <div className="form-input mb-4">
                    <select className="form-select form-control" value={data.state} onChange={(event) => setData({...data, state: event.target.value})}>
                    <option value="0">Select State</option>
                      {citydata.map((item) => (
                        <option value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>              
                </div>
                <div className="form-group">
                  <label className="form-label fw-semibold">Zip Code</label>
                  <div className="form-input mb-4">
                    <Input type="tel" className="form-control" required validate pattern="[0-9]{5}" placeholder="Enter address" value={data.zip_code} onInput={(event) => setData({...data, zip_code: event.target.value})}/>
                  </div>
                </div>
                <Button type="submit" fill large className="btn theme-btn save-address w-100">
                  Save Changes
                </Button>
              </form>
            </div>
          </section>
        </div>
      </div>
    </Page>
  );
}
export default ProfileUpdatePage;